import * as React from 'react'

import { mplusApi } from 'redux/services/mplus'
import { GetMplusParams, MplusObject } from 'redux/services/mplus/types'

import { AppLayoutTable } from 'components/AppLayoutTable'
import { AppLoader } from 'components/AppLoader'
import { AppPagination } from 'components/AppPagination'
import { AppTable } from 'components/AppTable'

import { MPLUS_SERVICE_TYPE_TEXT, MPLUS_STATUS_TEXT } from 'constants/mplus'

import { formatDate } from 'shared/libs'
import { EmptyDetails } from 'shared/ui'

import { Details } from './components/Details'
import { Filters } from './components/Filters'
import { Statistics } from './components/Statistics'

export const MPlusPage = () => {
  const [selectedRowId, setSelectedRowId] = React.useState<
    MplusObject['id'] | undefined
  >()
  const [filters, setFilters] = React.useState<GetMplusParams>({
    limit: 10,
    offset: 0,
  })
  const [fetch, fetchState] = mplusApi.useLazyGetMplusQuery()

  React.useEffect(() => {
    fetch(filters)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters])

  const onChangeFilters = (newFilters: GetMplusParams) => {
    newFilters.limit = filters.limit
    newFilters.offset = filters.offset
    setFilters(newFilters)
  }

  return (
    <>
      <AppLayoutTable
        title="М+/(Мурабаха)"
        header={<Filters onSubmit={onChangeFilters} />}
        statistics={<Statistics filters={filters} />}
        sidebarOpened={Boolean(selectedRowId)}
        sidebar={
          selectedRowId ? (
            <Details
              id={selectedRowId}
              onClose={() => setSelectedRowId(undefined)}
            />
          ) : (
            <EmptyDetails />
          )
        }
      >
        {fetchState.isLoading && <AppLoader />}
        {fetchState.data && fetchState.isSuccess && (
          <>
            <AppTable
              onClickRow={item => setSelectedRowId(item.id)}
              dataSource={fetchState.data.results}
              selected={{
                value: selectedRowId,
                key: 'id',
              }}
              headers={[
                {
                  data: 'ID',
                  key: 'id',
                },
                {
                  data: 'ИНН',
                  key: 'inn',
                },
                {
                  data: 'Название',
                  key: 'name',
                },
                {
                  data: 'Дата создания',
                  key: 'created_at',
                  render: (_, item) => formatDate(item.created_at),
                },
                {
                  data: 'Сервис',
                  key: 'service_type',
                  render: (_, item) =>
                    MPLUS_SERVICE_TYPE_TEXT[item.service_type],
                },
                {
                  data: 'Статус',
                  key: 'status',
                  render: (_, item) => MPLUS_STATUS_TEXT[item.status],
                },
              ]}
            />

            <AppPagination
              forcePage={filters.offset! / filters.limit!}
              onPageChange={nextPage => {
                setFilters({
                  ...filters,
                  offset: (nextPage - 1) * filters.limit!,
                })
              }}
              count={fetchState.data.count / filters.limit!}
            />
          </>
        )}
      </AppLayoutTable>
    </>
  )
}
